var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77922 8.15269C9.691 8.15269 11.2408 6.54014 11.2408 4.55095C11.2408 2.56177 9.691 0.949219 7.77922 0.949219C5.86743 0.949219 4.31763 2.56177 4.31763 4.55095C4.31763 6.54014 5.86743 8.15269 7.77922 8.15269Z",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7136 20.1578H0.867188V18.557C0.867188 16.6465 1.59659 14.8143 2.89494 13.4634C4.19329 12.1125 5.95423 11.3535 7.79037 11.3535C9.62651 11.3535 11.3875 12.1125 12.6858 13.4634C13.9842 14.8143 14.7136 16.6465 14.7136 18.557V20.1578Z",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M13.1744 0.949219C14.016 0.949219 14.8231 1.29706 15.4182 1.91623C16.0133 2.5354 16.3476 3.37517 16.3476 4.25081C16.3476 5.12644 16.0133 5.96621 15.4182 6.58538C14.8231 7.20455 14.016 7.55239 13.1744 7.55239",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M17.7822 0.949219C18.522 0.949219 19.2314 1.25498 19.7545 1.79924C20.2776 2.34349 20.5714 3.08166 20.5714 3.85136C20.5714 4.62105 20.2776 5.35922 19.7545 5.90348C19.2314 6.44774 18.522 6.7535 17.7822 6.7535",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.4233 10.7656C16.6247 11.2411 17.6589 12.085 18.3892 13.1855C19.1195 14.286 19.5114 15.5912 19.5131 16.9286V18.5574H17.3977",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M19.7822 9.57812C20.8382 9.9961 21.7473 10.7378 22.3893 11.7052C23.0312 12.6725 23.3757 13.8199 23.3772 14.9955V16.4272H21.5177",
    stroke: "#178477",
    strokeWidth: 1.52728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBooking);
export default __webpack_public_path__ + "static/media/user-booking.1099b93ad0647710b11a3e82c43c4ec1.svg";
export { ForwardRef as ReactComponent };